import { isRtl } from "~/helpers/locale";
import type { CountryIso, CountryKey, ProductName } from "~/types";

export default function useLocalization() {
  const { locale, messages } = useI18n();
  const { $tt } = useNuxtApp();

  return {
    locale,
    tt: $tt,
    rtl: computed(() => isRtl(locale.value)),
    countries: computed(() => messages.value[locale.value].countries as Record<CountryIso, string>),
    tCountry: (country: CountryIso) => $tt(`countries.${country}`),
    tWaitDays: (country: CountryKey) => $tt(`waiting_days.${country}`),
    tProductLabel: (product: ProductName, format: 'long' | 'label') => $tt(`products.${format}.${product}`),
    tValidityRange: (country: CountryKey) => $tt(`validity_range_${country}`),
  };
}